import { render, staticRenderFns } from "./subform.vue?vue&type=template&id=9f09f458&scoped=true&"
import script from "./subform.vue?vue&type=script&lang=js&"
export * from "./subform.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f09f458",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/3ztxUiUz/0/ifirst/dt-survey/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9f09f458')) {
      api.createRecord('9f09f458', component.options)
    } else {
      api.reload('9f09f458', component.options)
    }
    module.hot.accept("./subform.vue?vue&type=template&id=9f09f458&scoped=true&", function () {
      api.rerender('9f09f458', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/FormGen/FormDesign/ItemConfig/subform.vue"
export default component.exports